/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
// @ts-nocheck
import { __assign, __rest } from "tslib";
import 'swiper/swiper-bundle.min.css';
import './Slider.css';
import React from 'react';
import { Navigation, Pagination, EffectFade, EffectCube, EffectFlip, Autoplay, Grid } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { forwardRefWithAs } from '../../utils/types/PropsWithAsAttributes';
import { cn } from '../../utils/bem';
var cnSlider = cn('Slider');
export var Slider = forwardRefWithAs(function (props, ref) {
    var _a = props || {}, children = _a.children, className = _a.className, _b = _a.centerNavigationOnMobile, centerNavigationOnMobile = _b === void 0 ? true : _b, type = _a.type, otherProps = __rest(_a, ["children", "className", "centerNavigationOnMobile", "type"]);
    return (React.createElement(Swiper, __assign({ ref: ref, modules: [Navigation, Pagination, EffectFade, EffectCube, EffectFlip, Autoplay, Grid] }, otherProps, { className: cnSlider({
            'centered-navigation-mobile': centerNavigationOnMobile,
            type: type
        }, [className]) }), children));
});
export var SliderItem = SwiperSlide;
export var renderFraction = function (currentClass, totalClass, index, total) {
    return "<span class=".concat(currentClass, ">").concat(index, "</span> <span class=\"delimiter\"></span> <span class=").concat(totalClass, ">").concat(total, "</span>");
};
